//二级路径加前缀
export const getContentPath=(url)=>{
  const ecologyContentPath = window['ecologyContentPath']||"";//二级路径
  if(ecologyContentPath!="" && !!url){
    if(url.startsWith("/") && !url.startsWith(ecologyContentPath)){
      url = ecologyContentPath+url;
    }else if(url.startsWith("http")){
      let origin = window.location.origin;
      if(!origin){
        origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
      }
      if(url.startsWith(origin) && !url.startsWith(origin+ecologyContentPath)){
        url = url.replace(origin,origin+ecologyContentPath);
      }
    }
  }
  return url;
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/util/contentPath.tsx